<faxe-page-layout [showClock]="true">
  <form [formGroup]="formGroup">
    <mat-card appearance="outlined" class="ctx-large">
      <faxe-page-title></faxe-page-title>
      <button
        mat-raised-button
        color="primary"
        class="wide"
        (click)="onFinish()"
      >
        MÅLGÅNG
      </button>
      <div class="border-panel">
        <h3 class="header">Välj ryttare</h3>
        <faxe-chip-list
          #riderComponent
          class="chiplist"
          [enableInput]="true"
          inputHeading="Ny ryttare..."
          [parentFormGroup]="formGroup"
          formCtrlName="rider"
          [itemsSet]="riderViewDataItems"
          (itemUnSelectedEvent)="riderUnselected()"
          (itemSelectedEvent)="onSelectedRiderView($event)"
          (lastItemUnSelectedEvent)="onRiderLastUnSelected()"
        ></faxe-chip-list>
      </div>

      @if (selectedRider && finish) {
      <button
        mat-raised-button
        color="primary"
        class="wide"
        (click)="onReport()"
      >
        RAPPORTERA
      </button>
      }

      <h1 class="header">
        <b>{{ stopTime }}</b>
      </h1>
      <h1 class="header">
        <b>{{ totalTime }}</b>
      </h1>

      @if (finish) {
      <mat-slider
        min="0"
        max="10000"
        step="250"
        showTickMarks="true"
        discrete="true"
        [displayWith]="formatLabel"
      >
        <input
          matSliderThumb
          [value]="value"
          (change)="onSliderChange($event)"
        />
      </mat-slider>
      }
    </mat-card>

    <faxe-rolling-hist-list [listItems]="listItems"></faxe-rolling-hist-list>
  </form>
</faxe-page-layout>
